import { Schema } from "nutso";

import { Owner } from "../models/Owner";

export const ownerSchema: Schema<Owner, any, any> = {
  type: "object",
  properties: {
    uid: {
      type: "string",
    },
    emailAddress: {
      type: "string",
    },
    orgId: {
      type: "string",
    },
  },
};
